import { render, staticRenderFns } from "./WeekTab.vue?vue&type=template&id=ac5bac46&scoped=true"
import script from "./WeekTab.vue?vue&type=script&lang=js"
export * from "./WeekTab.vue?vue&type=script&lang=js"
import style0 from "./WeekTab.vue?vue&type=style&index=0&id=ac5bac46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac5bac46",
  null
  
)

export default component.exports